const Index = () => import('./index.vue');

export default [
    {
        path: '/cargo-stock',
        component: Index
    }
];